import React from "react";
import { motion } from "framer-motion";

export const KineticLines = ({ lines, className = "", as: Tag = "h1", delay = 0.2 }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className="block will-change-transform"
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 1,
            delay: delay + i * 0.14,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          {line.map((seg, j) => (
            <span key={j} className={seg.accent ? "text-[#8E9AEA]" : undefined}>
              {seg.t}
            </span>
          ))}
        </motion.span>
      </span>
    ))}
  </Tag>
);
